import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Default JSON imports include hyphenated keys; `import *` only re-exports valid identifiers (Vite).
import ccsCommonEnglishConstants from 'ccs-ui-components/dist/assets/i18n/english/common-component.json';
import ccsCommonFrenchConstants from 'ccs-ui-components/dist/assets/i18n/french/common-component.json';
import ccsCommonGermanConstants from 'ccs-ui-components/dist/assets/i18n/german/common-component.json';
import ccsCommonSpanishConstants from 'ccs-ui-components/dist/assets/i18n/spanish/common-component.json';

import commonComponentsConstants from './english/common-component.json';
import commonDashboardConstant from './english/common-dashboard.constant.json';
import commonConstant from './english/common.json';
import controlPlaneConstant from './english/control-plane.constant.json';
import journeyBuilderConstant from './english/journey-builder.constant.json';

import spanishCommonComponentsConstants from './spanish/common-component.json';
import spanishCommonDashboardConstant from './spanish/common-dashboard.constant.json';
import spanishCommonConstant from './spanish/common.json';
import spanishControlPlaneConstant from './spanish/control-plane.constant.json';
import spanishJourneyBuilderConstant from './spanish/journey-builder.constant.json';

import frenchCommonComponentsConstants from './french/common-component.json';
import frenchCommonDashboardConstant from './french/common-dashboard.constant.json';
import frenchCommonConstant from './french/common.json';
import frenchControlPlaneConstant from './french/control-plane.constant.json';
import frenchJourneyBuilderConstant from './french/journey-builder.constant.json';

import germanCommonComponentsConstants from './german/common-component.json';
import germanCommonDashboardConstant from './german/common-dashboard.constant.json';
import germanCommonConstant from './german/common.json';
import germanControlPlaneConstant from './german/control-plane.constant.json';
import germanJourneyBuilderConstant from './german/journey-builder.constant.json';

i18n
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    // the translations
    // (tip move them in a JSON file and import them,
    // or even better, manage them via a UI: https://react.i18next.com/guides/multiple-translation-files#manage-your-translations-with-a-management-gui)
    resources: {
      en: {
        translation: {
          ...journeyBuilderConstant,
          ...controlPlaneConstant,
          ...commonDashboardConstant,
          ...commonConstant,
          ...commonComponentsConstants,
          ...ccsCommonEnglishConstants,
        }
      },
      de: {
        translation: {
          ...germanCommonDashboardConstant,
          ...germanCommonConstant,
          ...germanControlPlaneConstant,
          ...germanJourneyBuilderConstant,
          ...germanCommonComponentsConstants,
          ...ccsCommonGermanConstants,
        }
      },
      es: {
        translation: {
          ...spanishJourneyBuilderConstant,
          ...spanishControlPlaneConstant,
          ...spanishCommonDashboardConstant,
          ...spanishCommonConstant,
          ...spanishCommonComponentsConstants,
          ...ccsCommonSpanishConstants,
        }
      },
      fr: {
        translation: {
          ...frenchJourneyBuilderConstant,
          ...frenchCommonConstant,
          ...frenchCommonDashboardConstant,
          ...frenchControlPlaneConstant,
          ...frenchCommonComponentsConstants,
          ...ccsCommonFrenchConstants,
        }
      }
    },
    lng: 'en', // if you're using a language detector, do not define the lng option
    fallbackLng: 'en',

    interpolation: {
      escapeValue: false // react already safes from xss => https://www.i18next.com/translation-function/interpolation#unescape
    }
  });

export default i18n;
